import React, { useRef, useState, useEffect } from 'react';
import './About.scss';
import Header from 'modules/Shared/components/Header/Header';
import Footer from 'modules/Shared/components/Footer/Footer';
import FlightChecker from 'modules/MainModule/components/FlightChecker/FlightChecker';
import Contact from 'modules/MainModule/components/Contact/Contact';
import { colorBackgroundBrightness } from 'data/common.data';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Carousel from 'react-bootstrap/Carousel';
import ContactUs from '../ContactUs/ContactUs';

interface DataTextModel {
    key: string;
    text: string;
    type: string;
}
interface AboutCardModel {
    key: string;
    class: string;
    name: string;
    position: string;
    pic: string;
    about: DataTextModel[];
}
interface NewsDataModel {
    key: string,
    header: string;
    content: string;
    link: string;
}
const aboutCards: AboutCardModel[] = [
    {
        key: 'about-1',
        class: '',
        name: 'Sneharthi Roy',
        position: 'Founder & CEO',
        pic: '/images/others/image-sneharthi.png',
        about: [
            {
                key: 'data-1',
                text: 'Sneharthi has extensive experience building organizations from startup to exit. Previously he managed a $5B P&L with 2,200 employees. His work produced four disruptions:',
                type: ''
            },
            {
                key: 'data-2',
                text: 'digital transformation at CheapOAir',
                type: 'pt'
            },
            {
                key: 'data-3',
                text: 'contact center automation with Al at Travelomind',
                type: 'pt'
            },
            {
                key: 'data-4',
                text: 'data science with 13 million data points daily at Cognitive Junction',
                type: 'pt'
            },
            {
                key: 'data-5',
                text: '3,500 seat expansion of IT and BPO services at Epixtar',
                type: 'pt'
            },
            {
                key: 'data-6',
                text: 'He has led subscription business models three times through 140,000 SaaS customers, platform development for Fortune 100-500, and Al-based conversation in social media.',
                type: ''
            }
        ]
    },
    {
        key: 'about-2',
        class: 'small-screen-padding-top',
        name: 'Anish Chatterjee',
        position: 'Co-Founder & Chief Solutions Architect',
        pic: '/images/others/image-anish.png',
        about: [
            {
                key: 'data-1',
                text: 'Anish has over two decades of experience architecting enterprise solutions, driving new technology initiatives, and building innovative technology solutions for Fortune 500 companies and startups across the globe.',
                type: ''
            },
            {
                key: 'data-2',
                text: 'His background includes nearly two decades as Technology Lead and Solution architect at Computer Associates and also at Cognizant. Anish has served as Chief Solution architect for several marquee customers in US and Europe.',
                type: ''
            }
        ]
    },
    {
        key: 'about-3',
        class: 'small-screen-padding-top',
        name: 'Vladimir Poletaev',
        position: 'Co-Founder & Chief Insurance Officer',
        pic: '/images/others/image-vladimir.jpg',
        about: [
            {
                key: 'data-1',
                text: 'Vladimir is an established, high-energy leader with a track record of results in travel and insurance technology.',
                type: ''
            },
            {
                key: 'data-2',
                text: 'His work focuses on building teams and client relationship ecosystems based on, among other considerations, global sustainability and local cultural relevancy.',
                type: ''
            }
        ]
    }
];
const newsCards: NewsDataModel[] = [
    {
        key: 'news-1',
        header: '',
        content: 'Tune Protect EMEIA and AirLegit Team up: Enhancing Customer\'s Travel Experience Leveraging Technology',
        link: 'https://www.linkedin.com/feed/update/urn:li:activity:7122547569112604673'
    },
    // {
    //     key: 'news-2',
    //     header: '',
    //     content: '',
    //     link: 'https://www.linkedin.com/posts/tuneprotect-emeia-digital-enabler_tune-protect-emeia-and-airlegit-partnership-activity-7110171681305862144-qoPa?utm_source=share&utm_medium=member_desktop'
    // },
    {
        key: 'news-3',
        header: '',
        content: 'AirLegit partners with Applied Warranty & Insurance Services to offer travel insurance throughout The U.S',
        link: 'https://www.traveldailynews.com/regional-news/airlegit-partners-with-applied-warranty-amp-insurance-services-to-offer-travel-insurance-throughout-the-u-s/'
    },
    {
        key: 'news-4',
        header: '',
        content: 'AirLegit to offer travel insurance via platform',
        link: 'https://www.itij.com/latest/news/airlegit-offer-travel-insurance-platform?utm_source=hootsuite&utm_medium=linkedin&utm_term=itij%3A+international+travel+%26+health+insurance+journal&utm_content=f6f06ea0-f0cd-4e7a-b6ba-36d9e710c655&utm_campaign=Social'
    },
    {
        key: 'news-5',
        header: '',
        content: 'Battleface partners with AirLegit to launch FlightGuard48 globally',
        link: 'https://www.linkedin.com/feed/update/urn:li:activity:7031634530700533760'
    }
];

const About = (props: any) => {
    const gotoLink = (link: string) => {
        // window.location.href = link;
        window.open(link, '_blank')
    };
    const [nameDivHeight, setNameDivHeight] = useState(0);
    const [posDivHeight, setPosDivHeight] = useState(0);
    const updateDivHeights = () => {
        const nameDiv = document.getElementById('targetNameDiv');
        if (nameDiv) {
            const newHeight = nameDiv.clientHeight;
            setNameDivHeight(newHeight);
        }
        const posDiv = document.getElementById('targetPosDiv');
        if (posDiv) {
            const newHeight = posDiv.clientHeight;
            setPosDivHeight(newHeight);
        }
    };
    useEffect(() => {
        updateDivHeights();
        window.scrollTo(0, 0);
        window.addEventListener('resize', updateDivHeights);
        return () => {
            window.removeEventListener('resize', updateDivHeights);
        };
    }, []);
    const nameDiv = (card: AboutCardModel) => {
        let heightData: string = 'auto';
        if (window.innerWidth >= 768) heightData = nameDivHeight + 'px';
        if (card.key !== 'about-3') return (
            <div style={{ height: heightData }} className='name text-l2'>
                {card.name.toUpperCase()}
            </div>
        );
        else return (
            <div id='targetNameDiv' className='name text-l2'>
                {card.name.toUpperCase()}
            </div>
        );
    }
    const posDiv = (card: AboutCardModel) => {
        let heightData: string = 'auto';
        if (window.innerWidth >= 768) heightData = posDivHeight + 'px';
        if (card.key !== 'about-2') return (
            <div style={{ height: heightData }} className='position'>
                {card.position}
            </div>
        );
        else return (
            <div id='targetPosDiv' className='position'>
                {card.position}
            </div>
        );
    }
    const cardItems = aboutCards.map((card: AboutCardModel) => {
        let classData: string = 'col-md-4';
        if (card.class) classData = `${classData} ${card.class}`;
        return (
            <div key={card.key} className={classData}>
                <div className='about-card-wrapper'>
                    <div className='pic-wrapper'>
                        <img src={card.pic} alt={card.name} />
                    </div>
                    <div className='content-wrapper'>
                        {nameDiv(card)}
                        {posDiv(card)}
                        <div className='about'>
                            {
                                card.about.map((data: DataTextModel) => {
                                    if (data.type === 'pt') return (
                                        <ul key={data.key} className=''>
                                            <li>
                                                {data.text}
                                            </li>
                                        </ul>
                                    );
                                    else return (
                                        <p key={data.key} className=''>
                                            {data.text}
                                        </p>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    });
    const newsCardItems = newsCards.map((card: NewsDataModel) => {
        return (
            <Carousel.Item key={card.key} interval={3000}>
                <div className='data-content'>
                    {/* <div className='header-content text-med text-l2'>
                        {card.header}
                    </div> */}
                    <div className='text-content text-l2'>
                        {card.content}
                    </div>
                    <div className='btn-wrapper'>
                        <button className='btn-primary' onClick={() => gotoLink(card.link)}>
                            Learn More &#8594;
                        </button>
                    </div>
                </div>
                {/* <div className='carousel-caption-content'>
                    <Carousel.Caption>
                    </Carousel.Caption>
                </div> */}
            </Carousel.Item>
        );
    })
    const contentData: string = 'Get "Flight Watcher" to alert on your flight delay, cancellation and choose alternative airlines, nearby airports, re-booking, or re-accommodation by your airline.';
    const headerBg: string = '/images/backgrounds/ALEG-Image-About_Header.jpg';
    const styleData = { backgroundImage: `linear-gradient(${colorBackgroundBrightness}, ${colorBackgroundBrightness}), url(${headerBg})` };
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>About Flight Watcher, smart way to travel</title>
                    <meta name='description' content={contentData} />
                </Helmet>
            </HelmetProvider>
            <Header />
            <div className='page-min-height about-data-container'>
                <div className='header-container container-side-padding container-content-padding' style={styleData}>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <h1>
                                        AirLegit&#169;
                                    </h1>
                                    <p className=''>
                                        AirLegit&#169; is a technology provider of air
                                        travel tools, designed to enable companies to improve their travelers' end-to-end journeys.
                                    </p>
                                    <p className=''>
                                        AirLegit&#169; alleviates persistent travel friction by anticipating and remedying flight disruptions with an innovative combination of flight performance data analytics, proactive personalized traveler support and ready-made travel disruption automation tools.
                                    </p>
                                </div>
                                <div className='col-md-6'>
                                    <div className='logo-wrapper' style={{ maxWidth: '300px' }}>
                                        <img src='/images/others/ALEG-Image-Airlines_HeaderForeground.png' alt='air travel tools' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='news-container container-side-padding container-content-padding' id='news'>
                    <div className='container-small-width'>
                        <div className='container-fluid no-padding'>
                            <div className='row'>
                                <div className='col-md-10 offset-md-1'>
                                    <Carousel>
                                        {newsCardItems}
                                    </Carousel>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='our-team-container container-side-padding container-content-padding'>
                    <div className='container-large-width'>
                        <div className='container-fluid no-padding'>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <h2>
                                        Our Team
                                    </h2>
                                    <p className=''>
                                        Meet the people who build the tools.
                                    </p>
                                </div>
                                <div className='col-md-8'>
                                    <div className='row'>
                                        {cardItems}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='flight-checker-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-12 no-padding'>
                                    <FlightChecker />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Contact />
            <Footer />
        </>
    );
};

export default About;